import { render, staticRenderFns } from "./EmailTable.vue?vue&type=template&id=6c6088b9"
import script from "./EmailTable.vue?vue&type=script&lang=js"
export * from "./EmailTable.vue?vue&type=script&lang=js"
import style0 from "./EmailTable.vue?vue&type=style&index=0&id=6c6088b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports